import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { UserCourseStepId, CourseStepAnswers } from '@business/entities/user_course';

export class ListMatchingBlockBloc extends BaseBloc {
  private readonly courseBloc = resolve(Blocs.userCourse);

  constructor(private readonly lessonId?: string) {
    super();
  }

  readonly loading = new LoadingState();

  onProgress = (stepId: string, progress: CourseStepAnswers) => this.courseBloc.onProgress(stepId, progress);
}
